//
import HrContractPeriodModel from '@/models/HumanResource/HrContractPeriod'
import HrContractTypeModel from '@/models/HumanResource/HrContractType'

//
export default [
  {
    name: 'structure_name',
    type: 'text-field',
    props: {
      label: 'Nombre',
    },
  },
  {
    name: 'hr_contract_type_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'name',
      itemValue: 'id',
      label: 'Tipo',
      model: HrContractTypeModel,
      noAsyncSearch: true,
      paramSearch: 'name',
    },
  },
  {
    name: 'hr_contract_period_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'name',
      itemValue: 'id',
      label: 'Periodo',
      model: HrContractPeriodModel,
      noAsyncSearch: true,
      paramSearch: 'name',
    },
  },
]